import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.82 1.086a2 2 0 0 0-3.253.627l-.67 1.56a2 2 0 0 1-.943 1.002L1.606 6.949a2 2 0 0 0-.52 3.203l8.804 8.804a2 2 0 0 0 3.203-.52l2.674-5.348a2 2 0 0 1 1-.944l1.562-.67a2 2 0 0 0 .627-3.252zM4.074 15.968a1 1 0 0 0-1.414 0l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414a1 1 0 0 0 0-1.414"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }